// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'
import Breadcrumb from '@uswitch/ev-components/lib/components/elements/breadcrumbs'
import connectBreadcrumb from '@r/connectors/breadcrumb'

export default connectBreadcrumb((props) => (
  <Breadcrumb {...props} sx={{ variant: 'compounds.breadcrumbs' }} />
))
